import * as React from 'react';
import { useContext } from "react";
import { SelectedPatientContext } from "../SelectedPatientContext.tsx";
import {Text, Spinner, Avatar, Caption1, Tab, TabList, Button} from "@fluentui/react-components";
import { Card, CardHeader, CardPreview, } from "@fluentui/react-components";
import { HeartPulse20Regular, TextBulletListSquareWarning20Regular, ClipboardTextEditRegular, TimelineRegular, FullScreenMaximizeFilled } from '@fluentui/react-icons';
import { ScenarioConfiguration } from './scenario-configuration.js';
import { SchedulerConfiguration } from './scheduler-configuration.js';
import { ControlPanelNavigation } from './control-panel-navigation.js';
import { HeartBeatChart } from './heart-beat-chart.js';
import { Console } from './console.js';
import { webLightTheme } from '@fluentui/react-components';
import { API_PATH } from '../Constants.ts';

export const Dashboard = () => {
    const { selectedPatientId} = useContext(SelectedPatientContext);
    const [selectedValue, setSelectedValue] =
        React.useState("manual");

    const onTabSelect = (event, data) => {
        setSelectedValue(data.value);
    };

    return <>
        <div className='control-panel-layout'>
            <aside className="sidenav">
                <ControlPanelNavigation />
            </aside>
            <main className="main">
                <div className="main-cards">
                    <Card size='large' className="card">
                        <div id="unityContainer">
                            <canvas id="unity-canvas" style={{ width: '100%' }} />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                appearance="outline"
                                icon={<FullScreenMaximizeFilled />}
                                onClick={() => window.Fullscreen?.()}
                            />
                        </div>
                    </Card>
                    <Card size='large' className="card">
                        <CardHeader style={{ marginLeft: '-12px', marginTop: '-12px' }} header={
                            <TabList defaultSelectedValue="manual" selectedValue={selectedValue} onTabSelect={onTabSelect} >
                                <Tab value="manual" icon={<ClipboardTextEditRegular />}>
                                    Manually controlled therapy
                                </Tab>
                                <Tab value="scheduler" icon={<TimelineRegular />}>
                                    Scheduler-controlled therapy
                                </Tab>
                            </TabList>
                        } />

                        <div style={{ height: '385px', overflow: 'auto', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {selectedValue === "manual" && <ScenarioConfiguration />}
                            {selectedValue === "scheduler" && <SchedulerConfiguration selectedPatientId={selectedPatientId} />}
                        </div>
                    </Card>
                    <Card size='large' className="card" style={{ maxHeight: '262px', paddingBottom: '50px' }}>
                        <CardHeader image={<HeartPulse20Regular />} header={<Text weight="semibold">Heart rate [bpm - beats per minute]</Text>} />
                        <HeartBeatChart />
                    </Card>
                    <Card size='large' className="card" style={{ height: '100%' }}>
                        <CardHeader image={<TextBulletListSquareWarning20Regular />} header={<Text weight="semibold">Console</Text>} />
                        <Console />
                    </Card>
                </div>
            </main>
        </div>
    </>;
};